import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "compare-print__title" }
const _hoisted_2 = { class: "__product-header" }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "__product-info" }
const _hoisted_5 = { class: "__product_price-color" }
const _hoisted_6 = { class: "__visualScales-item" }
const _hoisted_7 = {
  key: 0,
  class: "__visualScales-itemHeadingCompare"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "__visualScales-item" }
const _hoisted_11 = {
  key: 0,
  class: "__visualScales-itemHeadingCompare"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "compare-print__category-title" }
const _hoisted_15 = { class: "__compareView-listing" }
const _hoisted_16 = { class: "__visualScales-itemHeadingCompare" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "__visualScales-description" }
const _hoisted_19 = { class: "compare-print__category-title" }
const _hoisted_20 = { class: "__compareView-listing" }

import { routeKey } from '@drapejs/core';
import { computed, inject, onMounted } from 'vue';
import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';
import useCompareProducts from '@/composables/useCompareProducts';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComparePrint',
  setup(__props) {

const { websiteText } = useWebsiteTexts();

const pageTitle = computed(() => websiteText('compare_compare').value);

const sustainabilityTitle = computed(() => websiteText('compare_sustainability').value);
const functionsTitle = computed(() => websiteText('compare_functions').value);

const productGroupSize = 3;
const columns = computed(() => new Array(productGroupSize).fill(null));

const compareProducts = useCompareProducts();
const products = computed(() => compareProducts.loadedProductsData.value);
const productGroups = computed(() => products.value.reduce((groups, product) => {
  let currentGroup = groups[0];
  if (!currentGroup || currentGroup.length === productGroupSize) {
    currentGroup = [];
    groups.unshift(currentGroup);
  }

  currentGroup.push(product);

  return groups;
}, []).reverse());

const toLitiumMediaUrl = inject<(string, any) => string>(toLitiumMediaUrlKey, () => '');

function getImageUrl(imageId: string, options = {}) {
  if (imageId === '00000000-0000-0000-0000-000000000000') return '';
  return toLitiumMediaUrl(imageId, options);
}

const route = inject(routeKey);

onMounted(async () => {
  const queryProducts = route?.query.products?.split(',').map((p) => p.trim()) || [];
  compareProducts.add(queryProducts);
  await compareProducts.fetchProducts();
  if (window.location.pathname.indexOf('/!') !== 0) {
    setTimeout(() => {
      print();
    }, 2000);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(pageTitle)), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productGroups), (productGroup) => {
      return (_openBlock(), _createElementBlock("table", {
        key: productGroup[0].articleNumber,
        class: "__product-group"
      }, [
        _createElementVNode("colgroup", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (_, idx) => {
            return (_openBlock(), _createElementBlock("col", { key: idx }))
          }), 128))
        ]),
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup, (product) => {
              return (_openBlock(), _createElementBlock("th", {
                key: product.articleNumber
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    class: "__product-image",
                    alt: product.name,
                    src: getImageUrl(product.imageId, { maxWidth: 300 })
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(product.name) + " ", 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(product.color), 1),
                      _createElementVNode("span", null, _toDisplayString(product.price), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup, (product) => {
              return (_openBlock(), _createElementBlock("td", {
                key: product.articleNumber,
                class: "__visualScales"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (getImageUrl(product.shapeInfo.imageId))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(product.shapeInfo.label), 1))
                    : _createCommentVNode("", true),
                  (getImageUrl(product.shapeInfo.imageId))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "__visualScales-image",
                        src: getImageUrl(product.shapeInfo.imageId)
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (getImageUrl(product.shapeInfo.imageId))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "__visualScales-description",
                        innerHTML: product.shapeInfo.description
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup, (product) => {
              return (_openBlock(), _createElementBlock("td", {
                key: product.articleNumber,
                class: "__visualScales"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (getImageUrl(product.fitInfo.imageId))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(product.fitInfo.label), 1))
                    : _createCommentVNode("", true),
                  (getImageUrl(product.fitInfo.imageId))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "__visualScales-image",
                        src: getImageUrl(product.fitInfo.imageId)
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (getImageUrl(product.fitInfo.imageId))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "__visualScales-description",
                        innerHTML: product.fitInfo.description
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup, (product) => {
              return (_openBlock(), _createElementBlock("td", {
                key: product.articleNumber
              }, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(sustainabilityTitle)), 1),
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.sustainability, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.title
                    }, _toDisplayString(item.title), 1))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup, (product) => {
              return (_openBlock(), _createElementBlock("td", {
                key: product.articleNumber,
                class: "__visualScales"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.visualScales, (scale) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: scale.heading,
                    class: "__visualScales-item"
                  }, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(scale.heading), 1),
                    _createElementVNode("img", {
                      class: "__visualScales-image",
                      src: getImageUrl(scale.scaleImageId)
                    }, null, 8, _hoisted_17),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(scale.scaleShortDescription), 1)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup, (product) => {
              return (_openBlock(), _createElementBlock("td", {
                key: product.articleNumber
              }, [
                _createElementVNode("h2", _hoisted_19, _toDisplayString(_unref(functionsTitle)), 1),
                _createElementVNode("ul", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.functions, (func) => {
                    return (_openBlock(), _createElementBlock("li", { key: func }, _toDisplayString(func), 1))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    }), 128))
  ], 64))
}
}

})